var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovieCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89056 5.5641H5.80951M10.7433 9.83593L14.2621 11.5978C14.6269 11.8235 15.0096 11.6905 14.9998 11.2197L14.9751 4.99311C14.944 4.48206 14.6473 4.34261 14.2104 4.57879L10.7334 6.18505M2.70268 13H9.02568C9.96604 13 10.7284 12.2347 10.7284 11.2906L10.7433 9.09811L10.7284 4.7094C10.7284 3.76533 9.96604 3 9.02568 3H2.70268C1.76232 3 1 3.76533 1 4.7094V11.2906C1 12.2347 1.76232 13 2.70268 13Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieCamera);
export default __webpack_public_path__ + "static/media/movie_camera.3c044be4c323e6d9b241376099a6e35b.svg";
export { ForwardRef as ReactComponent };